import { render } from "./PanelInfoPopover.vue?vue&type=template&id=bfa3d03e&scoped=true"
import script from "./PanelInfoPopover.vue?vue&type=script&lang=js"
export * from "./PanelInfoPopover.vue?vue&type=script&lang=js"

import "./PanelInfoPopover.vue?vue&type=style&index=0&id=bfa3d03e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa3d03e"]])

export default __exports__